import { render, staticRenderFns } from "./EntidadFederativa.vue?vue&type=template&id=6b0b86d3"
import script from "./EntidadFederativa.vue?vue&type=script&lang=js"
export * from "./EntidadFederativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0b86d3')) {
      api.createRecord('6b0b86d3', component.options)
    } else {
      api.reload('6b0b86d3', component.options)
    }
    module.hot.accept("./EntidadFederativa.vue?vue&type=template&id=6b0b86d3", function () {
      api.rerender('6b0b86d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/infoBase/EntidadFederativa.vue"
export default component.exports